import {
  AddProductsToCurrentCartRequestedAction,
  AddProductsToCurrentCartRequestedPayload,
  addProductsToCurrentCartFailed,
  addProductsToCurrentCartSucceeded
} from '../../carts/cartsSlice';
import {
  ApiCartAddProductsToCartFailedAction,
  ApiCartAddProductsToCartSucceededAction,
  apiCartAddProductsToCartFailedType,
  apiCartAddProductsToCartRequested,
  apiCartAddProductsToCartSucceededType
} from '../../api/cart/addProductsToCartApi';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';
import { put } from 'typed-redux-saga';
import waitForSucceededOrFailedAction from '../session/waitForSucceededOrFailedAction';

function* addProductsToCurrentCartSaga({
  payload
}: AddProductsToCurrentCartRequestedAction): Generator {
  const {
    actionId: requestedActionId,
    customOrderType,
    productCodesWithQuantities,
    trackAddToCart
  }: AddProductsToCurrentCartRequestedPayload = payload;
  const actionId: number = generateActionId();

  yield* put(
    apiCartAddProductsToCartRequested({
      actionId,
      customOrderType,
      parentActionId: requestedActionId,
      productCodesWithQuantities: productCodesWithQuantities.map((entry) => ({
        code: entry.code,
        quantity: entry.quantity,
        tracking: entry.tracking
          ? {
              itemListId: entry.tracking.itemListId ?? null,
              itemListName: entry.tracking.itemListName ?? null
            }
          : null
      }))
    })
  );

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiCartAddProductsToCartSucceededType,
    typeof apiCartAddProductsToCartFailedType,
    ApiCartAddProductsToCartSucceededAction,
    ApiCartAddProductsToCartFailedAction
  >(actionId, apiCartAddProductsToCartSucceededType, apiCartAddProductsToCartFailedType);

  if (waitResult.type === 'succeeded') {
    const { productCodesWithAddedQuantities, cart, isNewCart, allQuantityAdded } =
      waitResult.action.payload.result;
    const sourceCustomOrderType = waitResult.action.payload.sourceCustomOrderType;
    const targetCustomOrderType = waitResult.action.payload.targetCustomOrderType;
    yield* put(
      addProductsToCurrentCartSucceeded({
        cart: convertCartToStateCart(cart),
        customOrderType: targetCustomOrderType,
        isNewCart,
        productCodesWithQuantities: productCodesWithAddedQuantities,
        requestedActionId,
        allQuantityAdded,
        sourceCustomOrderType,
        ...(trackAddToCart === undefined ? {} : { trackAddToCart })
      })
    );
  } else {
    const { failedReason } = waitResult.action.payload;
    yield* put(
      addProductsToCurrentCartFailed({
        requestedActionId,
        failedReason
      })
    );
  }
}

export default addProductsToCurrentCartSaga;
